import { MutationTree } from "vuex";
import { AlarmMaskingState, ResponseForMasking } from "./types";
import { getDefaultState } from "./state";

export const mutations: MutationTree<AlarmMaskingState> = {
	setGroupId(state, groupId: number) {
		state.groupId = groupId;
	},
	setResponses(state, responses: ResponseForMasking[]) {
		state.responses = responses;
	},
	resetState(state) {
		Object.assign(state, getDefaultState());
	},
	setMaxAlarmsToShow(state, maxCount: number) {
		if(maxCount !== null && maxCount >= 200) {
			state.maxAlarmsToShow = maxCount;
		}
	},
	setAreaMaskingMode(state, areaMaskingMode: boolean) {
		state.isAreaMaskingMode = areaMaskingMode;
	},
	setIsUpdatingArea(state, isUpdatingArea: boolean) {
		state.isUpdatingArea = isUpdatingArea;
	}
};
